function initializeSwiper() {
    var swiperElement = document.querySelector('.mySwiper');
    if (!swiperElement) {
        console.error('Swiper element not found');
        return;
    }

    const swiper = new Swiper('.mySwiper', {
        slidesPerView: 4,
        spaceBetween: 30,
        // autoplay: {
        //   delay: 5000,
        // },
        autoplay: false,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            320: {
                slidesPerView: 2,
                spaceBetween: 15
            },
            360: {
                slidesPerView: 2,
                spaceBetween: 15
            },
            989: {
                slidesPerView: 4,
                spaceBetween: 15
            },
            1024: {
                slidesPerView: 4,
                spaceBetween: 15
            },
            1900: {
                slidesPerView: 4,
                spaceBetween: 30
            }
        }
    });
}


function checkSwiperInitialization() {
    var swiperElement = document.querySelector('.mySwiper');
    if (swiperElement && swiperElement.querySelector('.swiper-wrapper')) {
        initializeSwiper();
    } else {
        //keep checking Swiper wrapper until found
        setTimeout(checkSwiperInitialization, 1000);
    }
}

// window.addEventListener('DOMContentLoaded', function () {
//     console.log("ON LOADED SWIPER!!!!!!!!");
//     setTimeout(checkSwiperInitialization, 2000);
// });
// window.addEventListener('resize', function () {
//     console.log("ON RESIZE SWIPER!!!!!!!!");
//     setTimeout(checkSwiperInitialization, 100);
// });

// checkSwiperInitialization();

window.onload = function () {
    setTimeout(checkSwiperInitialization, 100); // Delay of 0.1 seconds
};